import * as currency from 'currency.js';

export const PEN = (value: currency.Any) =>
    currency(value, { symbol: 'S/', decimal: '.', separator: ',', precision: 2 });
export const USD = (value: currency.Any) =>
    currency(value, { symbol: '$', decimal: '.', separator: ',', precision: 2 });
